<template>
  <component
    :is="$q.screen.gt.md ? 'div' : 'q-carousel'"
    v-model="slide"
    :class="['slider', {
      'row q-col-gutter-xl': $q.screen.gt.md,
    }]"
    transition-prev="slide-right"
    transition-next="slide-left"
    :autoplay="false"
    animated
    infinite
    padding
    height="100%"
    swipeable
  >
    <component
      :is="$q.screen.gt.md ? 'div' : 'q-carousel-slide'"
      v-for="(item, key, index) in $t('pages.for_business.testimonials')"
      :key="item.title"
      :name="index"
      :class="{ 'col item-shadow': $q.screen.gt.md }"
    >
      <img
        :src="`/img/partner_logo/partner-${key}.png`"
        :alt="key"
        class="feedback-logo"
      >
      <h2 class="item-title">
        {{ item.title }}
      </h2>
      <p
        :class="['item-text', {
          expanded: feedbacksExpanded[key],
        }]"
        v-html="item.text"
      />
      <div
        v-if="key !== 'mastercard'"
        class="item-expand cursor-pointer inline-block q-mb-md"
        @click="feedbacksExpanded[key] = !feedbacksExpanded[key]"
      >
        {{ $t(`label.${feedbacksExpanded[key] ? 'hide' : 'expand'}`) }}
      </div>
    </component>
    <template #control>
      <q-carousel-control
        class="flex justify-center q-gutter-sm"
        position="bottom"
        :offset="[18, 18]"
      >
        <div
          v-for="(_, index) in 3"
          :key="index"
          class="q-pa-sm cursor-pointer"
          @click="slide = index"
        >
          <div
            :class="['dot', slide === index ? 'bg-primary' : 'bg-grey']"
          />
        </div>
      </q-carousel-control>
    </template>
  </component>
</template>

<script>
export default {
  name: 'PartnerFeedback',
  data() {
    return {
      slide: 0,
      feedbacksExpanded: {
        s7: false,
        borets: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.slider {
  padding: 90px 32px 32px 32px;

  @media screen and (max-width: $breakpoint-md-max) {
    padding-top: 30px;
  }
}

.item-shadow {
  box-shadow: 0 10px 20px rgba(#292929, .07);
  border-radius: 12px;
  padding: 40px;
  margin: 0 12px;
}

.item-expand {
  color: #4b83bc;
  border-bottom: 1px dotted;
}

.item-title {
  font-size: 28px;
  font-weight: 300;
  margin: 12px 0 32px 0;
}

.item-text {
  color: rgba(#000, .5);
  overflow: hidden;
  max-height: 264px;

  &.expanded {
    max-height: unset;
  }
}

.feedback-logo {
  height: 85px;
  width: auto;
}

.dot {
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.q-carousel__slide {
  min-height: 550px;
}
</style>
